export default `float s=2.;
    float e=0.;
    vec3 q=vec3(3.0,3.0,.0);
    for(int i=0; i++<7; p=q-abs(p-q*.4))
      s*=e=15./min(dot(p,p),15.),
      p=abs(p)*e-2.;
    return (length(p.xz)-.5)/s;
  }`